// extracted by mini-css-extract-plugin
export default {"why":"WhyChoose_why__T18yO"};